import React from 'react';

const SearchKitContext = React.createContext(null);

export default SearchKitContext;
